import { render } from "./AposPagesManager.vue?vue&type=template&id=9d2e24bc&scoped=true"
import script from "./AposPagesManager.vue?vue&type=script&lang=js"
export * from "./AposPagesManager.vue?vue&type=script&lang=js"

import "./AposPagesManager.vue?vue&type=style&index=0&id=9d2e24bc&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d2e24bc"],['__file',"page/ui/apos/components/AposPagesManager.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9d2e24bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9d2e24bc', __exports__)) {
    api.reload('9d2e24bc', __exports__)
  }
  
  module.hot.accept("./AposPagesManager.vue?vue&type=template&id=9d2e24bc&scoped=true", () => {
    api.rerender('9d2e24bc', render)
  })

}


export default __exports__